import { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useIsCompanySetter(
  defaultIsCompany: boolean,
  onSetIsCompany: () => void
) {
  const [isCompany, setIsCompany] = useState(defaultIsCompany)
  const client = useApiClientUser()
  const setIsCompanyMutation = useMutation({
    mutationFn: async () => {
      return await client.user.onboardingControllerSetIsCompany(
        { isCompany },
        { secure: true }
      )
    },
    onSuccess: onSetIsCompany,
  })

  useEffect(() => {
    setIsCompanyMutation.mutate()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompany])

  useEffect(() => {
    setIsCompany(defaultIsCompany)
  }, [defaultIsCompany])

  return {
    isCompany,
    setIsCompany,
  }
}

export { useIsCompanySetter }
